import { Observable } from "rxjs";
import { ChatCommentModel } from "../models/chat-comment-model";

export abstract class BaseChatService {
    abstract getComments(entityId: string): Observable<ChatCommentModel[]>;
    abstract addComment(entityId: string, commentText: string): Observable<ChatCommentModel>;
}
